<template>
    <div class="m-system-error">
        <div class="system-error__img">
            <img src="@studio/assets/img/img_empty_serv_def.svg">
        </div>
        <dl class="system-error__info">
            {{ msg }}
        </dl>
    </div>
</template>
<script>

export default {
    name: 'SystemError',
    data() {
        return {
            msg: {
                type: String,
            },
        }
    },
    created() {
        this.msg = window.sessionStorage.getItem('message-503') || '服务器异常'
    },
}
</script>
<style lang="less" scoped>
    .m-system-error{
        padding-top: 280px;
        margin: auto;
        text-align: center;
    }
    .system-error__img{
        margin: auto;
        width: 292px;
        height: 174px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .system-error__info{
        margin-top: 48px;
        color: #3E4352;
        font-size: 24px;
    }
</style>
